module.exports = __webpack_public_path__ + "img/caret-left.8023f612.svg";